import React from "react"
import { Box, Flex, ContentCell } from "src/components/Grid"
import { NavLink } from "react-router-dom"
import { PrimaryButton } from "@infotech/uikit-button"
import { InlineTitle } from "@infotech/uikit-text"
import { compose, withState } from "recompact"
import tooltip from "@infotech/uikit-tooltip"
import * as Icons from "@infotech/uikit-icons"
import { VerticalDivider } from "../Divider"
import styles from "./styles.css"

const { AddIcon } = Icons
const TooltipPrimaryButton = tooltip(PrimaryButton)

const tabEnhancer = compose(
  withState(`Icon`, `setIcon`, ({ iconName }) => Icons[iconName]),
)

const Tab = ({ Icon, text, path }) => (
  <NavLink
    className={styles[`tab-box`]}
    to={path}
    activeStyle={{
      boxShadow: `inset 0 -2px rgb(40, 128, 255)`,
    }}
  >
    {Icon && <Icon size="large" />}
    {text && <InlineTitle>{text}</InlineTitle>}
  </NavLink>
)

const EnhancedTab = tabEnhancer(Tab)

export default ({
  onAdd,
  tabs = [],
  disableAdd,
  children,
  addButtonTooltipText,
}) => (
  <Box flex align="center" bb>
    <ContentCell align="center" justify="center">
      <div data-testid="create-entity-button">
        <TooltipPrimaryButton
          className={styles[`button-add`]}
          onClick={onAdd}
          disabled={disableAdd}
          tooltip={addButtonTooltipText}
          tooltipConfig={{
            placement: `right`,
          }}
        >
          <AddIcon size="small" color="white" />
        </TooltipPrimaryButton>
      </div>
    </ContentCell>
    {tabs.length ? <VerticalDivider height={24} /> : null}
    {tabs.length ? (
      <Flex className={styles[`tab-wrapper`]}>
        {tabs.map(params => (
          <EnhancedTab {...params} />
        ))}
      </Flex>
    ) : null}
    {children}
  </Box>
)
